module.exports = __webpack_public_path__ + "./fonts/s-core_-_coresanscr-75extrabold-webfont.ttf";